var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundsquares2Demo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100vw",
    height: "auto",
    viewBox: "0 0 1920 944",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_614_1887)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 -400H1920V944H0V-400Z",
    fill: "#0C0C11"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_614_1887",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -400,
    width: 1920,
    height: 1344
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -400H1920V944H0V-400Z",
    fill: "url(#paint0_radial_614_1887)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_614_1887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 -16H0V112H128M128 -16V112M128 -16H255.999V112H128",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 -16H384V112H256V-16Z",
    fill: "#404249",
    fillOpacity: 0.337255,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 -16H512V112H384V-16Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 -16H640V112H512V-16Z",
    fill: "#404249",
    fillOpacity: 0.294118,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 -16H895.999V112H1024M1024 -16V112M1024 -16H1152V112H1024M640 -16H768V112H640V-16Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 -16H1280V112H1152V-16Z",
    fill: "#404249",
    fillOpacity: 0.690196,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408 -16H1280V112H1408M1408 -16V112M1408 -16H1536M1408 112H1536M1536 -16V112M1536 -16H1664V112H1536",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1664 -16H1792V112H1664V-16Z",
    fill: "#404249",
    fillOpacity: 0.368627,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 112H0V239.999H128M128 112V239.999M128 112H255.999V239.999H128M384 112H256V239.999H384M384 112V239.999M384 112H512V239.999H384",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 112H640V239.999H512V112Z",
    fill: "#404249",
    fillOpacity: 0.552941,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 112H640V239.999H768M768 112V239.999M768 112H895.999M768 239.999H895.999M895.999 112V239.999M895.999 112H1024M895.999 239.999H1024M1024 112V239.999M1024 112H1152V239.999H1024M1408 112H1280V239.999H1408M1408 112V239.999M1408 112H1536M1408 239.999H1536M1536 112V239.999M1536 112H1664V239.999H1536M1792 112H1920V239.999H1792V112Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 240H128V368H0V240Z",
    fill: "#404249",
    fillOpacity: 0.592157,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.999 240H255.999V368H127.999V240Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 240H384V368H256V240Z",
    fill: "#404249",
    fillOpacity: 0.509804,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 240H512V368H384V240Z",
    fill: "#404249",
    fillOpacity: 0.180392,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 240V368H768V240H640Z",
    fill: "#404249",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 240H512V368H640M640 240V368M640 240H768V368H640",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 240H896V368H768V240Z",
    fill: "#404249",
    fillOpacity: 0.466667,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.999 240H1024V368H895.999V240Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 240H1152V368H1024V240Z",
    fill: "#404249",
    fillOpacity: 0.188235,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 240H1152V368H1280M1280 240V368M1280 240H1408V368H1280",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408 240H1536V368H1408V240Z",
    fill: "#404249",
    fillOpacity: 0.960784,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1536 240H1664V368H1536V240Z",
    fill: "#404249",
    fillOpacity: 0.101961,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 368H256V496H384M384 368V496M384 368H511.999M384 496H511.999M511.999 368V496M511.999 368H639.999V496H511.999M1664 240H1792V368H1664V240Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 368H768V496H640V368Z",
    fill: "#404249",
    fillOpacity: 0.737255,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896 368H768V496H896M896 368V496M896 368H1024V496H896",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 368H1152V496H1024V368Z",
    fill: "#404249",
    fillOpacity: 0.298039,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 368H1152V496H1280M1280 368V496M1280 368H1408V496H1280",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408 368H1536V496H1408V368Z",
    fill: "#404249",
    fillOpacity: 0.858824,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1664 368H1536V496H1664M1664 368V496M1664 368H1792M1664 496H1792M1792 368V496M1792 368H1920V496H1792M128 496H0V623.999H128M128 496V623.999M128 496H255.999V623.999H128M384 496H256V623.999H384M384 496V623.999M384 496H512V623.999H384M768 496H640V623.999H768M768 496V623.999M768 496H896V623.999H768",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 496H895.999V623.999H1024V496Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 496H1024V623.999H1152V496Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 496H1280V623.999H1152V496Z",
    fill: "#404249",
    fillOpacity: 0.756863,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 496H1408V623.999H1280V496Z",
    fill: "#404249",
    fillOpacity: 0.227451,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408 496H1536V623.999H1408V496Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1536 496H1664V623.999H1536V496Z",
    fill: "#404249",
    fillOpacity: 0.713726,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792 496H1664V623.999H1792M1792 496V623.999M1792 496H1920V623.999H1792M127.999 624H255.999V752H127.999V624ZM256 624H383.999V752H256V624Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 624H512V752H384V624Z",
    fill: "#404249",
    fillOpacity: 0.776471,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 624H640V752H512V624Z",
    fill: "#404249",
    fillOpacity: 0.486275,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 624H768V752H640V624Z",
    fill: "#404249",
    fillOpacity: 0.384314,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896 624H768V752H896M896 624V752M896 624H1024M896 752H1024M1024 624V752M1024 624H1152M1024 752H1152M1152 624V752M1152 624H1280M1152 752H1280M1280 624V752M1280 624H1408M1280 752H1408M1408 624V752M1408 624H1536M1408 752H1536M1536 624V752M1536 624H1664M1536 752H1664M1664 624V752M1664 624H1792V752H1664",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792 624H1920V752H1792V624Z",
    fill: "#404249",
    fillOpacity: 0.509804,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 752H128V880H0V752Z",
    fill: "#404249",
    fillOpacity: 0.560784,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.999 752H255.999V880H127.999V752Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 752H384V880H256V752Z",
    fill: "#404249",
    fillOpacity: 0.635294,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 752H512V880H384V752Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 752H640V880H512V752Z",
    fill: "#404249",
    fillOpacity: 0.776471,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 752H768V880H640V752Z",
    fill: "#404249",
    fillOpacity: 0.196078,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 752H896V880H768V752Z",
    fill: "#404249",
    fillOpacity: 0.580392,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.999 752H1024V880H895.999V752Z",
    fill: "#404249",
    fillOpacity: 0.235294,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 752H1152V880H1024V752Z",
    fill: "#404249",
    fillOpacity: 0.482353,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 752H1280V880H1152V752Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 752H1408V880H1280V752Z",
    fill: "#404249",
    fillOpacity: 0.666667,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1536 752H1408V880H1536M1536 752V880M1536 752H1664V880H1536",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1664 752H1792V880H1664V752Z",
    fill: "#404249",
    fillOpacity: 0.294118,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792 752H1920V880H1792V752ZM0 880H128V1008H0V880Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.999 880H255.999V1008H127.999V880Z",
    fill: "#404249",
    fillOpacity: 0.686275,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 880H256V1008H384M384 880V1008M384 880H511.999V1008H384M1024 880H895.999V1008H1024M1024 880V1008M1024 880H1152M1024 1008H1152M1152 880V1008M1152 880H1280M1152 1008H1280M1280 880V1008M1280 880H1408M1280 1008H1408M1408 880V1008M1408 880H1536V1008H1408M640 880H768V1008H640V880Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1536 880H1664V1008H1536V880Z",
    fill: "#404249",
    fillOpacity: 0.156863,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792 880H1664V1008H1792M1792 880V1008M1792 880H1920V1008H1792",
    stroke: "#404249",
    strokeWidth: 0.576
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_614_1887",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(960 272) scale(960 672)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.946
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_614_1887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 944,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundsquares2Demo);
export default __webpack_public_path__ + "static/media/backgroundsquares2-Demo.7db059f3c2be46c6acaf0ba1b517ee19.svg";
export { ForwardRef as ReactComponent };